import tippy, { Props as TippyProps, hideAll as hideAllTippy } from 'tippy.js';

export const tippyDefaultOptions: Partial<TippyProps> = {
    theme: 'light',
};

/**
 * Add a tooltip on elements with the attribute [data-tippy]
 * 
 * @see https://atomiks.github.io/tippyjs/
 */
export function initTippy() : void {
    document.querySelectorAll<HTMLElement>('[data-tippy]').forEach($el => {
        const options: Partial<TippyProps> = {
            ...tippyDefaultOptions,
            content: $el.dataset.tippy as string,
            allowHTML: true,
            onShow() {
                // Fermeture de toutes les autres instances Tippy à l'ouverture d'une
                hideAllTippy();
            },
        };

        tippy($el, options);
    });

    // Fermeture de toutes les instances Tippy à l'appuie sur la touche Echap
    document.addEventListener('keydown', evt => {
        if ('Escape' === evt.key) {
            hideAllTippy();
        }
    });
}
